import { USERS } from "../../Constants/Endpoinst";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchCreateUser = async (body) => {
    const method = "POST";
    const response = await ApiRequestInterceptor(USERS.createUser, method, body);

    // ✅ tu Lambda responde 201 cuando crea el usuario
    if (response.code === 201 && response.data?.user?.userId) {
        return response;
    }

    // ✅ si viene error controlado del backend
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
};